import $ from 'jquery';

$(() => {
    const carouselElems = [...document.querySelectorAll('[data-owl-carousel]')];

    carouselElems.forEach((el) => {
        const $el = $(el);
        const defaults = {
            navText: [
                '<svg class="transform rotate-180" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g clip-rule="evenodd" fill="currentColor" fill-rule="evenodd"><path d="m4 12c0-.5523.44772-1 1-1h14c.5523 0 1 .4477 1 1s-.4477 1-1 1h-14c-.55228 0-1-.4477-1-1z"></path><path d="m11.2929 4.29289c.3905-.39052 1.0237-.39052 1.4142 0l7 7.00001c.3905.3905.3905 1.0237 0 1.4142l-7 7c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l6.2929-6.2929-6.2929-6.29289c-.3905-.39053-.3905-1.02369 0-1.41422z"></path></g></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g clip-rule="evenodd" fill="currentColor" fill-rule="evenodd"><path d="m4 12c0-.5523.44772-1 1-1h14c.5523 0 1 .4477 1 1s-.4477 1-1 1h-14c-.55228 0-1-.4477-1-1z"></path><path d="m11.2929 4.29289c.3905-.39052 1.0237-.39052 1.4142 0l7 7.00001c.3905.3905.3905 1.0237 0 1.4142l-7 7c-.3905.3905-1.0237.3905-1.4142 0s-.3905-1.0237 0-1.4142l6.2929-6.2929-6.2929-6.29289c-.3905-.39053-.3905-1.02369 0-1.41422z"></path></g></svg>'
            ],
        };
        const options = $.extend(defaults, $el.data('owl-carousel'));

        console.log(options, 'options');

        $el.owlCarousel(options);
    });
});
